import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { RoleName } from 'src/app/@shared/constants/Constant';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { IGroupChatFilterModel, ISrListGroupList } from 'src/app/model/internalGroupChat.model';
import { IGetMemberViewModel } from 'src/app/service/memeber.model';
import { VendorService } from 'src/app/service/vendor.service';
import { InternalGroupChatService } from '../../internal-group-chat.service';
import { EMPTY_GUID_VALUE, NOTIFICATION_WARNING_TIME } from '../../../shared/properties/application.properties';

@Component({
  selector: 'app-internal-group-chat-dialog',
  templateUrl: './internal-group-chat-dialog.component.html',
  styleUrls: ['./internal-group-chat-dialog.component.css'],
})
export class InternalGroupChatDialogComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription = new Subscription();
  public user: ILoggedInUserViewModel;
  public loader: boolean;
  public getSRListGroupListPayload: IGroupChatFilterModel;
  public sRListGroupList: ISrListGroupList[];
  public internalMemberList: IGetMemberViewModel[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public serviceRequestID: string,
    private _internalGroupChatService: InternalGroupChatService,
    private _vendorService: VendorService,
    private _toast: ToastrService,
  ) {}

  ngOnInit() {
    this.loader = true;
    this.user = JSON.parse(localStorage.getItem('user'));
    this.getSRListGroupListPayload = {
      memberId: this.user.memberId,
      serviceRequestId: this.serviceRequestID,
      messageText: null,
    };
    this.getGroupChatList();
    if (
      this.user.role !== RoleName.CustomerAdmin &&
      this.user.role !== RoleName.CustomerCoordinator &&
      this.user.role !== RoleName.VendorAdmin &&
      this.user.role !== RoleName.VendorCoordinator &&
      this.user.role !== RoleName.VendorDriver &&
      this.user.role !== RoleName.InternalReadOnly
    ) {
      this.getInternalMemberList();
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
    this._internalGroupChatService.loadGroupChatSubject$.next({
      groupDetail: null,
      serviceRequestDetail: null,
    });
  }

  getGroupChatList() {
    this._subscriptions.add(
      this._internalGroupChatService.getSRListGroupList(this.getSRListGroupListPayload).subscribe(
        (response) => {
          this.loader = false;
          this.sRListGroupList = response.data;
        },
        (error) => {
          this.loader = false;
          console.log(error);
        },
      ),
    );
  }

  getInternalMemberList() {
    this.loader = true;
    this._subscriptions.add(
      this._vendorService.getMemberListByCustomerID(EMPTY_GUID_VALUE).subscribe(
        (response) => {
          this.internalMemberList = response;
          this.loader = false;
        },
        (error) => {
          this.loader = false;
          console.log(error);
          this._toast.warning('Unable to get the internal member list!', 'Warning', {
            timeOut: NOTIFICATION_WARNING_TIME,
            positionClass: 'toast-top-center',
          });
        },
      ),
    );
  }
}
